import React from 'react';
import styles from './MobileMenuFooter.scss';
import { MyJlFilled } from 'jl-design-system/components/icons/MyJlFilled';
import { MobilePhoneOutlined } from 'jl-design-system/components/icons/MobilePhoneOutlined';
import { FeedbackOutlined } from 'jl-design-system/components/icons/FeedbackOutlined';
import classNames from 'classnames';
import { FEEDBACK_LINK } from '../../../links';

export const MobileMenuFooter = () => {
  return (
    <div className={styles.footer} data-testid="mobile-menu-static-section">
      <ul>
        <li className={styles.footerLink}>
          <MyJlFilled className={styles.invertedIcon} size="medium" />
          <a href="/our-services/my-john-lewis">My John Lewis</a>
        </li>
        <li className={styles.footerLink}>
          <MobilePhoneOutlined className={styles.invertedIcon} size="medium" />
          <a href="/customer-services/shopping-with-us/our-apps">
            Download the John Lewis app
          </a>
        </li>
        <li className={styles.footerLink}>
          <FeedbackOutlined className={styles.invertedIcon} size="medium" />
          <a href={FEEDBACK_LINK} target="_blank" rel="noopener noreferrer">
            Leave feedback
          </a>
        </li>
        <li className={classNames(styles.footerLink, styles.footerNku)}>
          <a href="/content/never-knowingly-undersold">
            Never Knowingly Undersold
          </a>
        </li>
      </ul>
    </div>
  );
};
